import {Component, OnInit} from '@angular/core';
import {COOKIE_POLICY_ROUTE} from "../../app-routing.module";
import {CookieService} from "ngx-cookie-service";

@Component({
    selector: 'app-cookie-banner',
    templateUrl: './cookie-banner.component.html',
    styleUrl: './cookie-banner.component.scss',
    standalone: false
})
export class CookieBannerComponent implements OnInit{
  showBanner: boolean = false;

  constructor(private cookieService: CookieService) {}

  ngOnInit(): void {
    const userAcceptedCookies = this.cookieService.get('cookiesAccepted') === 'true';
    if (!userAcceptedCookies) {
      this.showBanner = true;
    }
  }

  acceptCookies(): void {
    this.cookieService.set('cookiesAccepted', 'true', 365);
    this.showBanner = false;
  }

  declineCookies(): void {
    this.cookieService.set('cookiesAccepted', 'false', 365);
    this.showBanner = false;
  }

  protected readonly COOKIE_POLICY_ROUTE:string = COOKIE_POLICY_ROUTE;

}
